import { render, staticRenderFns } from "./DialogView.vue?vue&type=template&id=6fc6d5a2&scoped=true"
import script from "./DialogView.vue?vue&type=script&lang=js"
export * from "./DialogView.vue?vue&type=script&lang=js"
import style0 from "./DialogView.vue?vue&type=style&index=0&id=6fc6d5a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc6d5a2",
  null
  
)

export default component.exports